import React, { useState, useEffect } from 'react';
import { sendToWebhook } from '../../api/client';
import { getContexts } from '../../api/contexts';
import TopBar from '../layout/TopBar';
import ChatInput from '../inbox/ChatInput';

function ChatView({ onNavigateToEntries }) {
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const [contexts, setContexts] = useState([]);
  const [selectedContextId, setSelectedContextId] = useState('');

  useEffect(() => {
    getContexts({ status: 'activo', limit: 50 })
      .then(res => setContexts(res.data || []))
      .catch(() => {});
  }, []);

  async function handleSend() {
    const content = input.trim();
    if (!content || sending) return;
    setSending(true);
    setResult(null);
    try {
      const contextId = selectedContextId ? parseInt(selectedContextId) : null;
      await sendToWebhook(content, contextId);
      setResult({ type: 'success', content });
      setInput('');
    } catch (err) {
      setResult({ type: 'error', message: err.message });
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="view-container chat-view">
      <TopBar title="Nuevo Predicado" />

      <div className="chat-focus-area">
        <div className="chat-focus-area__icon">✏️</div>
        <div className="chat-focus-area__hint">
          Escribe libremente — notas de reunión, decisiones, tareas o riesgos.<br />
          N8N + Gemini AI los clasificará y guardará automáticamente.
        </div>

        {result?.type === 'success' && (
          <div className="chat-result chat-result--success">
            <span>✓ Enviado a N8N para procesamiento</span>
            <button
              className="btn-link"
              onClick={onNavigateToEntries}
              style={{ marginLeft: 12, fontSize: 13 }}
            >
              Ver predicados →
            </button>
          </div>
        )}

        {result?.type === 'error' && (
          <div className="chat-result chat-result--error">
            ✗ Error al enviar: {result.message}
            <button
              className="btn-secondary"
              style={{ marginLeft: 12, fontSize: 12, padding: '3px 10px' }}
              onClick={() => handleSend()}
            >
              Reintentar
            </button>
          </div>
        )}
      </div>

      <div className="chat-context-bar">
        <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>Contexto:</span>
        <select
          className="filter-select"
          value={selectedContextId}
          onChange={e => setSelectedContextId(e.target.value)}
          style={{ minWidth: 200, fontSize: 13 }}
        >
          <option value="">Detectar automáticamente</option>
          {contexts.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>

      <ChatInput
        value={input}
        onChange={setInput}
        onSend={handleSend}
        sending={sending}
      />
    </div>
  );
}

export default ChatView;
